// App.js
import React from 'react';
import './App.css';
import VirtualMuseum from './VirtualMuseum';

function App() {
  return (
    <div className="App">
      <VirtualMuseum />
    </div>
  );
}

export default App;
